export default __webpack_public_path__ + "09c5210b553c1f435990f2b0c06a9138.png";